import { isNotNull, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { useIsFinchOnboardingEnabledForPlatform } from '../../externalServices/finch/useFinchIframe'
import { useOrg } from '../organization/useOrg'
import { usePayrollOpsFormStatus } from './config'

export const usePreferredPayrollView = (org: OrganizationDetailFragment | null | undefined) => {
  // Always call hooks unconditionally
  const finchConnectEnabled = useIsFinchOnboardingEnabledForPlatform(org)
  const formStatus = usePayrollOpsFormStatus(org?.id || 0) // Pass 0 as fallback, hook will handle invalid ID
  const isSurveyComplete = formStatus === 'complete'

  if (!org) return null

  const isFinchConnected = org.employers.find((employer) => employer?.finchConnection?.isActive)

  if (finchConnectEnabled && !isFinchConnected) {
    return 'read-access'
  }

  const isOnboarded = Boolean(org.isOnboarded)
  const isPayrollConnected = isOnboarded || Boolean(org.payrollConnection.payrollConnectedAt)
  const isDoneWithPayrollInstructions =
    isOnboarded || isPayrollConnected || Boolean(org.payrollConnection.payrollInstructionsCompletedAt)

  if (isDoneWithPayrollInstructions && !isSurveyComplete && org.employers.filter(isNotNull).length > 1) {
    return 'survey'
  }
  return 'write-access'
}

// Wrapper for context-based usage (single organization pages)
export const usePreferredPayrollViewFromContext = () => {
  const org = useOrg()
  return usePreferredPayrollView(org)
}
